// A popover that hangs on a button (tree settings, tour list, layers): opens on the button, closes on a press
// outside or Escape. It lives on <body>; sweep() removes the popovers whose button is no longer on the page.
const live = new Map(); // popover id -> { btn, pop, set, onOpen }
let bound = false;

/** VIS-128: panels never overlap. A popover opened where its CSS puts it moves, whole, clear of the time bar, an open
 *  card, the list of places, the map's buttons, the phone's Explore button and the top row: above the first it meets when there is room,
 *  else beside it, on the side it already leans to (VIS-142: right of the list on a portrait tablet). Where no such
 *  place is clear and the open list is in the way, the list folds (one press brings it back); otherwise (a phone with
 *  a card open) it stays where its CSS puts it. Every popover of the map controls and the northern-lights menu use it.
 *  A part a style hides while the popover is open (a sideways phone's card in Float and Dock) is no obstacle. */
export function fit(pop) {
  // its CSS spot (offset*: no transform, no entrance animation); a hidden obstacle's empty box at 0,0 never meets it
  const x0 = pop.offsetLeft, y0 = pop.offsetTop, w = pop.offsetWidth, h = pop.offsetHeight, M = 8, W = innerWidth,
    boxes = (but) => [...document.querySelectorAll('#dock,#card.open,#feature-card.open,#m-explore,#explore,.top-left,.top-actions,.controls')].filter((e) => !e.contains(pop) && e !== but && getComputedStyle(e).visibility !== 'hidden').map((e) => e.getBoundingClientRect()),
    meet = (o, m) => o.left < x + w + m && o.right > x - m && o.top < y + h + m && o.bottom > y - m, // m: the gap kept
    hit = (m) => obs.find((o) => meet(o, m));
  let obs = boxes(), x, y, o;
  const place = () => {
    x = x0; y = y0;
    for (let k = 0; k < 6 && (o = hit(M)); k++) {
      if (o.top - h - M >= M) y = o.top - h - M;
      else if (x + w / 2 > (o.left + o.right) / 2 && o.right + M + w <= W - M) x = o.right + M;
      else x = Math.max(M, o.left - w - M);
    }
    return !hit(0);
  };
  let ok = place();
  const list = document.querySelector('#explore'), fold = document.querySelector('#explore-fold');
  if (!ok && W > 760 && list && fold && !document.body.classList.contains('explore-collapsed')) {
    obs = boxes(list); // would the folded list leave a clear spot? then it folds
    if (place()) { fold.click(); obs = boxes(); ok = place(); }
  }
  pop.style.translate = ok ? `${x - x0}px ${y - y0}px` : '';
}

/** @returns {{ pop: HTMLElement, set: (on: boolean) => void, onOpen: (() => void) | null }} */
export function popup(id, btn, cls, label) {
  if (!bound) {
    bound = true;
    document.addEventListener('pointerdown', (e) => { for (const p of live.values()) if (!p.pop.hidden && !p.pop.contains(e.target) && !p.btn.contains(e.target)) p.set(false); });
    // VIS-128: in the capture phase, and the press stops here: the map's own Escape (close the card, stop the tour)
    // must not act as well. Focus that was in the popover goes back to its button (as the northern-lights menu does).
    addEventListener('keydown', (e) => {
      if (e.key === 'Escape') for (const p of live.values()) if (!p.pop.hidden) { e.stopImmediatePropagation(); if (p.pop.contains(document.activeElement)) p.btn.focus(); p.set(false); }
    }, true);
    addEventListener('resize', () => { for (const p of live.values()) if (!p.pop.hidden) fit(p.pop); });
  }
  live.get(id)?.pop.remove();
  const pop = document.createElement('div');
  pop.id = id; pop.className = cls; pop.setAttribute('role', 'dialog'); pop.setAttribute('aria-label', label); pop.hidden = true;
  document.body.appendChild(pop);
  const p = { btn, pop, onOpen: null, set(on) { pop.hidden = !on; btn.classList.toggle('on', on); btn.setAttribute('aria-expanded', String(on)); if (on) { p.onOpen?.(); if (pop.isConnected) fit(pop); } } };
  // VIS-128: opened from the keyboard (detail 0), the focus moves into the popover
  btn.setAttribute('aria-controls', id); // VIS-230: a phone's sheet finds the popover its press opened (chrome/phone.js)
  btn.onclick = (e) => { e.stopPropagation(); p.set(pop.hidden); if (!pop.hidden && e.detail === 0) pop.querySelector('button,input,a')?.focus(); };
  live.set(id, p);
  return p;
}

export function sweep() {
  for (const [id, p] of live) if (!p.btn.isConnected) { p.pop.remove(); live.delete(id); }
}
